export default __webpack_public_path__ + "static/media/007-bitcoin.ef77eab8.svg";